import React, { useContext, useEffect, useRef } from 'react';
import { Heading, Button } from '@americanexpress/dls-react';
import { BillingAddress } from '../../components/BillingAddress';
import {
    Ckyc,
    CommunicationPreference,
    Error,
    NameOnCard,
    CardPin,
    RelativeOfDirector
} from '../../components';
import AdditionalCard from '../../components/AdditionalCard/AdditionalCard';
import UserContext from '../../components/ContextComponent/UserContext';
import { CONSTANTS } from '../../constants';

function StageThree(props) {
    const { formData } = useContext(UserContext);
    const { errorData, setErrorData } = useContext(UserContext);
    const cardPinRef = useRef(null);
    const pattern = /^[0-9]{4}/;

    useEffect(() => {
        window.setITag("page3load", "success", "23643");
        window.setPageContext("CardOptionsAndSubmit");
    }, []);

    const handleOnClick = (e) => {
        if (formData.nameOnCard === '') {
            setErrorData({ ...errorData, nameOnCardRequired: true });
        }
        else if (!CONSTANTS.validation.pinPattern.test(formData.createCardPin) || formData.createCardPin < 4) {
            cardPinRef.current?.scrollIntoView({behavior:'smooth'});
            setErrorData({ ...errorData, cardPinRequired: true });
        }
        else if (!CONSTANTS.validation.pinPattern.test(formData.confirmCardPin) || formData.confirmCardPin < 4 
            || formData.createCardPin !== formData.confirmCardPin) {
            cardPinRef.current?.scrollIntoView({behavior:'smooth'});
            setErrorData(prev => {return { ...prev, confirmCardPinRequired: true }});
        }
        else if (formData.fatherOrMotherNameIsProvided === '') {
            setErrorData({ ...errorData, fatherOrMotherNameRequired: true });
        }
        else if (formData.fatherOrMotherName !== '' && formData.fatherOrMotherTitle === '') {
            setErrorData({ ...errorData, fatherOrMotherTitleRequired: true });
        }
        else if (formData.fatherFirstName === '' && formData.motherFirstName === '' && formData.spouseFirstName === '') {
            setErrorData({ ...errorData, fatherOrMotherFNameRequired: true });
        }
        else if (formData.fatherLastName === '' && formData.motherLastName === '' && formData.spouseLastName === '') {
            setErrorData({ ...errorData, fatherOrMotherLNameRequired: true });
        }
        else if ((formData.fatherFirstName !== '' && !CONSTANTS.validation.namePattern.test(formData.fatherFirstName))
            || (formData.motherFirstName !== '' && !CONSTANTS.validation.namePattern.test(formData.motherFirstName))
            || (formData.spouseFirstName !== '' && !CONSTANTS.validation.namePattern.test(formData.spouseFirstName))) {
            setErrorData({ ...errorData, fatherOrMotherFNameAlphaNumeric: true });
        }
        else if ((formData.fatherMiddleName !== '' && !CONSTANTS.validation.namePattern.test(formData.fatherMiddleName))
            || (formData.motherMiddleName !== '' && !CONSTANTS.validation.namePattern.test(formData.motherMiddleName))
            || (formData.spouseMiddleName !== '' && !CONSTANTS.validation.namePattern.test(formData.spouseMiddleName))) {
            setErrorData({ ...errorData, fatherOrMotherMNameAlphaNumeric: true });
        }
        else if ((formData.fatherLastName !== '' && !CONSTANTS.validation.namePattern.test(formData.fatherLastName))
            || (formData.motherLastName !== '' && !CONSTANTS.validation.namePattern.test(formData.motherLastName))
            || (formData.spouseLastName !== '' && !CONSTANTS.validation.namePattern.test(formData.spouseLastName))) {
            setErrorData({ ...errorData, fatherOrMotherLNameAlphaNumeric: true });
        }
        //else
        //    if (formData.communicationMode == '') {
        //    setErrorData({ ...errorData, communicationModeRequired: true })
        //}
        else if (formData.relOfDirector === '') {
            setErrorData({ ...errorData, relOfDirectorRequired: true })
        }
        else {
            setErrorData({
                ...errorData,
                nameOnCardRequired: false,
                fatherOrMotherNameRequired: false,
                fatherOrMotherTitleRequired: false,
                fatherOrMotherFNameRequired: false,
                fatherOrMotherLNameRequired: false,
                //communicationModeRequired: false, 
                fatherOrMotherFNameAlphaNumeric: false,
                fatherOrMotherMNameAlphaNumeric: false,
                fatherOrMotherLNameAlphaNumeric: false,
                relOfDirectorRequired: false,
            });
        }
    }
    return (
        <>
            <form onSubmit={props.handleSubmit}>
                <div className="pad-responsive">
                    <div className="stack body">
                        {props.data && (
                            <div className="stack-a">
                                <Error errorList={props.validation} />
                            </div>
                        )}
                        <Heading level="3" className="margin-2-b heading-3 text-uppercase"> Select Your Preferences for the Card </Heading>
                        <NameOnCard />
                        <div ref={cardPinRef}>
                            <CardPin />
                        </div >
                        <BillingAddress />
                        {props?.data?.journeyContent?.isAdditionalCardEnabled == true && <AdditionalCard />}
                        <Ckyc />
                        {props.data && (
                            <div className="stack-a">
                                <CommunicationPreference cardName={props?.data?.journeyContent?.productName} />
                            </div>
                        )}
                        <RelativeOfDirector />
                        <div>
                            By submitting this application, I agree that the 1st payment made on my Amex
                            card will be made via KYC complaint account maintained by me with another
                            Scheduled Commercial Bank in India and that in the event I make the first payment
                            via cash, my card will be permanently cancelled without any further notice and
                            will not be eligible for reinstatement. I also undertand that my personal and
                            sensitive information shall be used and shared by AEBC in accordance with its
                            <a href="https://www.americanexpress.com/in/legal-disclosures/privacy-statement.html" target="_blank"
                                rel="noopener noreferrer"> Privacy Statement</a> as updated on the website.
                        </div>
                    </div>
                </div>
                <div className="stack">
                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-4 flex flex-column flex-align-items-center pad-responsive">
                            {props.showBackButton && (
                                <Button aria-label="Back" styleType="primary" onClick={props.handleBackButton}>Back</Button>)
                            }
                        </div>
                        <div className="col-md-6 flex flex-column flex-align-items-center pad-responsive">
                            <Button aria-label="Submit" type="submit" styleType="primary" onClick={handleOnClick}>Submit</Button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default StageThree